const InboxIcon = ({ className }: { className?: string }) => (
	<svg
		class={className}
		fill='currentColor'
		height='14'
		viewBox='0 0 14 14'
		width='14'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M1.5 14C1.09722 14 0.746528 13.8507 0.447917 13.5521C0.149306 13.2535 0 12.9028 0 12.5V1.5C0 1.0875 0.149306 0.734376 0.447917 0.440626C0.746528 0.146876 1.09722 0 1.5 0H12.5C12.9125 0 13.2656 0.146876 13.5594 0.440626C13.8531 0.734376 14 1.0875 14 1.5V12.5C14 12.9028 13.8531 13.2535 13.5594 13.5521C13.2656 13.8507 12.9125 14 12.5 14H1.5ZM1.5 12.5H12.5V9.5H10.1667C9.84722 10.0972 9.40625 10.5799 8.84375 10.9479C8.28125 11.316 7.66667 11.5 7 11.5C6.31944 11.5 5.69792 11.3194 5.13542 10.9583C4.57292 10.5972 4.13889 10.1111 3.83333 9.5H1.5V12.5ZM7 10C7.55556 10 8.02778 9.80556 8.41667 9.41667C8.80556 9.02778 9 8.55556 9 8H12.5V1.5H1.5V8H5C5 8.55556 5.19444 9.02778 5.58333 9.41667C5.97222 9.80556 6.44444 10 7 10Z'
			fill='#F8F8F8'
		/>
	</svg>
)

export { InboxIcon }
